/* outer div is important for tab elements */
<template>
    <div class="badge-outer" ref="badgeOuter" @keypress.enter="toggleSelect" v-tooltip='text'>
        <div class="badge-wrap" :class="badgeClass" @click="toggleSelect" ref="badge">
            <div class="text-wrap">
                <span>{{text}}</span>
            </div>
            <div class="icon-wrap" v-if="this.selected !== null">
                <img :src="iconPath" :alt="iconPath">
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        type: {
            required: false,
            default: 'goal',
            type: String,
            // validator (val) {
            //     return [ 'goal', 'interest' ].indexOf(val) !== -1
            // }
        },
        text: {
            required: true,
            type: String
        },
        selected: {
            default: null,
            validator (val) {
                return [ true, false, null ].indexOf(val) !== -1 
            }
        },
        shape: {
            type: String,
            default: 'round',
            validator (val) {
                return  [ 'round', 'square' ].indexOf(val) !== -1
            }
        }
    },
    computed: {
        badgeClass () {
            let obj = {
                'selected': this.selected,
                'selectable': this.selected !== null
            }
            obj[this.type] = true
            obj[this.shape] = true
            return obj
        },
        icon () {
            return this.selected ? 'check' : 'plus'
        },
        iconPath () {
            let keys = {
                'plus': this.$images.plus,
                'check': this.$images.check  
            }
            return keys[this.icon]
        }
    },
    mounted () {
        // Enables user to tab to element and press enter to select it if it is a selectable badge
        if (this.selected !== null) {
            this.$refs.badge.tabIndex = -1
            this.$refs.badgeOuter.tabIndex = 0
        }
    },
    methods: {
        toggleSelect () {
            if (this.selected === null) {
                return
            }
            this.$emit('select', !this.selected)
        }
    }
}
</script>

<style lang="scss" scoped>
.badge-wrap {
    box-shadow: 0px 4px 30px rgba(0, 0, 0, 0.25);
    height: 40px;
    line-height: 20px;
    display: flex;
    flex-wrap: nowrap;
    padding: 5px;
    box-sizing: border-box; 
    border-radius: 11px;
    color: var(--main-color);
    user-select: none;
}
.text-wrap {
    max-width: 200px;
    flex-grow: 1;
    padding: 0 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    span {
        max-width: 100%;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        line-height: 20px;
        max-height: 20px;
    }
}
.round {
    border-radius: 22px;
}
.icon-wrap {
    width: 30px;
    height: 30px;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 50%;
}
.goal {
    background: var(--goal-color);
    .icon-wrap {
        background: var(--goal-color-shade);
    }
}
.interest {
    background: var(--interest-color);
    .icon-wrap {
        background: var(--interest-color-shade);
    }
}
.selectable {
    cursor: pointer;
}
.selected {
    background: var(--badge-selected);
    color: var(--secondary-color);
    .icon-wrap {
        background: var(--badge-selected-shade);
    }
}
.badge-outer:focus,
.badge-wrap:focus {
    outline: none;
}
.badge-outer:focus > .badge-wrap {
    outline: black solid 2px;
}
</style>